import React, {PureComponent} from 'react';
import {ModelLabelService} from "../../reference/model-label-service";
import {Container} from "aurelia-framework";
import {Router} from "aurelia-router";

export default class ReactReferenceDisplay extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            links: []
        };
    }

    componentDidMount() {
        this.reload();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.reference !== this.props.reference) {
            this.reload();
        }
    }

    reload() {
        let modelLabelService = Container.instance.get(ModelLabelService);

        if (!this.props.reference) {
            this.setState({links: []});
        }

        let references = this.props.reference;

        if (!Array.isArray(references)) {
            references = [references];
        }

        references = references.map((reference) => {
            return modelLabelService.getReferenceLinks(reference, false);
        });

        Promise.all(references).then((links) => {

            let newLinks = [];

            links.forEach(link => {

                if (link) {
                    newLinks.push(link);
                }
            });

            this.setState({links: newLinks});
        });
    }

    render() {

        const router = Container.instance.get(Router);

        return <>
            {this.state.links.map((link, index) => (
                <>
                    {index != 0 ? ', ' : ''}
                    {
                        link.linkParams ?
                            <a href={router.generate('view', link.linkParams)}>{link.label}</a> :
                            <span key={index}>{link.label}</span>
                    }
                </>

            ))}
        </>;
    }

}
